import { useCallback, useState, useLayoutEffect } from 'react';

const getBounds = el => {
  if (!el) {
    return {
      x: 0,
      y: 0,
      width: 0,
      height: 0,
    };
  }

  return {
    x: el.offsetLeft,
    y: el.offsetTop,
    width: el.offsetWidth,
    height: el.offsetHeight,
  };
};

const useComponentBounds = ref => {
  const [componentBounds, setComponentBounds] = useState(
    getBounds(ref ? ref.current : {}),
  );

  const recalculateBounds = useCallback(
    function recalculateBounds() {
      if (ref.current) {
        setComponentBounds(getBounds(ref.current));
      }
    },
    [ref],
  );

  useLayoutEffect(() => {
    if (!ref.current) {
      return undefined;
    }

    recalculateBounds();

    if (typeof ResizeObserver === 'function') {
      let resizeObserver = new ResizeObserver(() => recalculateBounds());
      resizeObserver.observe(ref.current);

      return () => {
        resizeObserver.disconnect(ref.current);
        resizeObserver = null;
      };
    }

    window.addEventListener('resize', recalculateBounds);

    return () => {
      window.removeEventListener('resize', recalculateBounds);
    };
  }, [ref.current]);

  return { bounds: componentBounds, recalculateBounds };
};

export default useComponentBounds;
